"use strict";

PF.Map = PF.Map || {};

PF.Map.Polyline = class Polyline extends PF.Widget {
    static get options() {
        return {
            models: undefined,
            modelsConfig: { filterConfig: { rule: '' } },
            polylineProperties: {
                hintContent: "Линия"
            },
            polylineOptions: {
                strokeColor: '#00FF0088',
                strokeWidth: 5
            },
            pathToCord: "",
        };
    }


    init() {
        if (this.models === undefined) {
            this.modelsConfig.list = this;
            this.models = new PF.Models(this.modelsConfig);
        } else {
            this.models.list = this;
            PF.Options.assignOptions(this.models, this.modelsConfig);
        }

        this.models.on('addOne', this.addOneSlot.bind(this));
        this.models.on('remove', this.removeSlot.bind(this));

        this.mapPolyline = new ymaps.Polyline([], this.polylineProperties, this.polylineOptions);
        this.map.geoObjects.add(this.mapPolyline);

        this.models.on('changed', () => {
            this.recreate();
        }, true);

    }

    recreate() {
        let cords = [];
        for (let i = 0; i < this.models.length; i++) {
            let point = this.models[i].get(this.pathToCord);
            if (point instanceof Array) {
                cords.push(point);
            } else {
                cords.push([
                    point.get("lat"),
                    point.get("lng")
                ]);
            }
        }
        this.mapPolyline.geometry.setCoordinates(cords);
    }

    addOneSlot(model) {
        this.recreate();
    }

    removeSlot(removed) {
        this.recreate();
    }

    update(limit = this.length) {
        this.models.update(limit);
    }

    destroy() {
        this.map.geoObjects.remove(this.mapPolyline);
        super.destroy();

    }
};